import axios from "axios";

// const MP_API_HIPERGAS = "https://a8d7-168-121-36-116.ngrok-free.app";
// const MP_API_NATURAL = "https://a8d7-168-121-36-116.ngrok-free.app";

const MP_API_HIPERGAS = "https://mphipergas.netizar.com";
const MP_API_NATURAL = "https://mpnatural.netizar.com";

const baseUrlEmpresa = (idEmpresa) =>
  Number(idEmpresa) === 1 ? MP_API_HIPERGAS : MP_API_NATURAL;

// Mensaje de error legible de una respuesta de la API de MP
export const mensajeError = (err, porDefecto) =>
  err?.response?.data?.message || err?.message || porDefecto;

// Crea la order en MP para el registro glpId. El monto y la referencia los
export const crearLinkGranel = async (idEmpresa, glpId, cuotas) => {
  const resp = await axios.post(`${baseUrlEmpresa(idEmpresa)}/api/link-granel/create`, {
    glpId,
    ...(cuotas ? { cuotas } : {}),
  });
  if (!resp.data?.ok || !resp.data?.data) {
    throw new Error(resp.data?.message || "Error generando el link en Mercado Pago");
  }
  return resp.data.data;
};

// Consulta la order en MP y actualiza el estado del registro (pagado / expirado)
export const verificarLinkGranel = async (idEmpresa, glpId) => {
  const resp = await axios.post(
    `${baseUrlEmpresa(idEmpresa)}/api/link-granel/verificar/${glpId}`
  );
  return resp.data?.data;
};

// Cancela la order en MP (si todavía se puede pagar) y anula el registro
export const anularLinkGranel = async (idEmpresa, glpId) => {
  const resp = await axios.post(
    `${baseUrlEmpresa(idEmpresa)}/api/link-granel/anular/${glpId}`
  );
  return resp.data?.data;
};
